import keyMirror from 'fbjs/lib/keyMirror';

const Actiontypes = keyMirror({
  ADMIN_LOGIN: 'ADMIN_LOGIN',
  ADMIN_LOGOUT: 'ADMIN_LOGOUT',
  STORE_ADMIN_DETAIL: 'STORE_ADMIN_DETAIL',
});

export default Actiontypes;
